import Header from "./Header";
import Footer from "./Footer";
import FloatingActions from "./FloatingActions";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1 pt-[88px]">{children}</main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
